import { render } from "./SatCatalogosView.vue?vue&type=template&id=6dec22c1&scoped=true"
import script from "./SatCatalogosView.vue?vue&type=script&lang=js"
export * from "./SatCatalogosView.vue?vue&type=script&lang=js"

import "./SatCatalogosView.vue?vue&type=style&index=0&id=6dec22c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dec22c1"]])

export default __exports__